import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Create a context with a default value
const TabContext = createContext({
  activeTab: 0,
  setActiveTab: () => {},
  homeActiveTab: 0,
  setHomeActiveTab: () => {},
  activePage: false,
  setActivePage: () => {},
  isActiveLink: false,
  setIsActiveLink: () => {}
});

// Custom hook for consuming the context
export const useTabContext = () => useContext(TabContext);

// Provider component to wrap your application
export const TabProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [homeActiveTab, setHomeActiveTab] = useState(0);
  const [activePage, setActivePage] = useState(false)
  const [isActiveLink, setIsActiveLink] = useState(
    JSON.parse(localStorage.getItem('isActiveLink')) || false
  );
  // const location = useLocation();
  useEffect(() => {
    // Update session storage whenever isActiveLink changes
    localStorage.setItem('isActiveLink', JSON.stringify(isActiveLink));
  }, [isActiveLink]);

  // useEffect(() => {
  //   // Restore state from session storage on location change
  //   const activePaths = ['/sessionDetailsToNominate'];
  //   setIsActiveLink(activePaths.includes(location.pathname));
  //   console.log('active from ')
  // }, [location]);

  return (
    <TabContext.Provider value={{ activeTab, setActiveTab,homeActiveTab, setHomeActiveTab, isActiveLink, setIsActiveLink, activePage, setActivePage }}>
      {children}
    </TabContext.Provider>
  );
};
